import { api } from './api';

export async function getLlmCostsByType(days = 7) {
  try {
    return await api.get(`/llm/costs-by-type?days=${days}`);
  } catch (error) {
    console.error('Error fetching LLM costs by type:', error);
    throw error;
  }
}

export async function getLlmCosts(days = 7) {
  try {
    return await api.get(`/llm/costs?days=${days}`);
  } catch (error) {
    console.error('Error fetching LLM costs:', error);
    throw error;
  }
}

export async function getSubscribers() {
  try {
    return await api.get('/users/subscribers');
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    throw error;
  }
}

export async function getMonthlyActiveUsers() {
  try {
    return await api.get('/users/monthly-active-users');
  } catch (error) {
    console.error('Error fetching monthly active users:', error);
    throw error;
  }
}

export async function getDailyActiveUsers() {
  try {
    return await api.get('/users/daily-active-users');
  } catch (error) {
    console.error('Error fetching daily active users:', error);
    throw error;
  }
}

export async function getYearlyActiveUsers() {
  try {
    return await api.get('/users/yearly-active-users');
  } catch (error) {
    console.error('Error fetching yearly active users:', error);
    throw error;
  }
}

export async function getChatUsage() {
  try {
    return await api.get('/chat-usage/chat-usage');
  } catch (error) {
    console.error('Error fetching chat usage:', error);
    throw error;
  }
}

export async function getVersionAdoption(days = 30) {
  try {
    return await api.get(`/version-adoption/version-adoption?days=${days}`);
  } catch (error) {
    console.error('Error fetching version adoption:', error);
    throw error;
  }
}

export async function getAvgCostPerSubscriber(days = 7) {
  try {
    return await api.get(`/llm/average-cost-per-subscriber?days=${days}`);
  } catch (error) {
    console.error('Error fetching average cost per subscriber:', error);
    throw error;
  }
}

export async function getAvgDailyCostPerSubscriber(days = 7) {
  try {
    return await api.get(`/llm/average-daily-cost-per-user?days=${days}`);
  } catch (error) {
    console.error('Error fetching average daily cost per user:', error);
    throw error;
  }
}

export async function getDailySubscriberUsage(days = 7) {
  try {
    return await api.get(`/llm/daily-subscriber-usage?days=${days}`);
  } catch (error) {
    console.error('Error fetching daily subscriber usage:', error);
    throw error;
  }
}

export async function getTotalCost(days = 7) {
  try {
    return await api.get(`/llm/total-cost?days=${days}`);
  } catch (error) {
    console.error('Error fetching total cost:', error);
    throw error;
  }
}

export async function getUniqueSubscribers(days = 7) {
  try {
    return await api.get(`/llm/unique-subscribers?days=${days}`);
  } catch (error) {
    console.error('Error fetching unique subscribers:', error);
    throw error;
  }
}
